// Item-state helpers for the Receive Shipping page.
// The container is marked "at port" and "at warehouse" as a whole; items are
// then received into the GH warehouse one by one.

const is1 = (v) => v === 1 || v === "1";

const inShipping = (product, shippingData) => shippingData && String(product?.shipping_id) === String(shippingData?.id);

// In this container, not yet received in the GH warehouse
export const pendingReceiveIds = (booking, shippingData) => (booking?.products || [])
    .filter((p) => inShipping(p, shippingData) && is1(p?.is_shipped) && !is1(p?.is_ship_received))
    .map((p) => p.id);

// Received in the GH warehouse from this container (can be removed again)
export const inWarehouseIds = (booking, shippingData) => (booking?.products || [])
    .filter((p) => inShipping(p, shippingData) && is1(p?.is_ship_received))
    .map((p) => p.id);

export const collectIds = (bookings, selectedIds, getIds, shippingData) => bookings
    .filter((b) => selectedIds.includes(b.id))
    .flatMap((b) => getIds(b, shippingData));

export const itemState = (product, shippingData) => {
    if (!inShipping(product, shippingData)) return "other";
    if (is1(product?.is_ship_received)) return "warehouse";
    if (is1(product?.is_shipped)) return "pending";
    return "other";
};
